/**
 * Directive for the Edit Portal Page Subscribe to Groups section.
 * Do not change the directive name here as its used dynamically in the view to load multiple instances
 */
SUGApp.directive("sugSubscribe", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionSubscribe.html",
        scope: {
            data: '=',
            section: '='
        },
        controller: ['$scope','$filter','$timeout','SUGUtilities','errorService','myGroupsService', 'portalService', '$sce', function($scope,$filter,$timeout,SUGUtilities,errorService,myGroupsService,portalService,sce) {
            // $scope refers to scope of this perticular directive instance.
            //init error service
            $scope.es = errorService.newInstance();
            $scope.es.init();

            $scope.frmObjSubscribe = {
                groupsSelect: [],
                firstname: '',
                lastname: '',
                email: '',
                mobile: '',
                textauth: false,
                selectedGroups: [],
                captchaValid: false,
            };
            $scope.showCaptcha = false;
            $scope.outcomes = {
                show: false,
                successhtml: '',
                failhtml: '',
                optinhtml: '',
            };

            /* Text Strings */
            $scope.strings = {
                  groupsDefault:  'Select Group(s)'
                , groupslabel:    'Receive messages regarding'
                , namelabel:      'Name'
                , firstname:      'First Name'
                , lastname:       'Last Name'
                , emaillabel:     'Email'
                , email:          'Email Address'
                , mobile:         'Mobile Number (optional)'
                , textOptInMessage:      'Opt in to receive text messages from this organization (US and Canada only).'
                , textOptInSubTextMessage:      "By checking this box, you agree to receive text messages from this organization via SignUpGenius. By opting in, you also agree to the <a href='/privacy' target='_blank'>Privacy Policy</a> & <a href='/terms-of-service' target='_blank'>Terms of Service</a>. Message and data rates may apply. Text HELP for help and STOP to cancel texts from ALL SignUpGenius organizers."
                , authorizenote:  'You can update your notification preferences via your account settings at any time.'
                , buttonSave:     'Subscribe'
                , tooltipSubscribePreview:     'This subscribe form is a non-functional preview. The subscribe form on the public portal page is fully functional.'
                , thankyou:       'Thank you for subscribing to:'
                , thankyouSingle:       'Thank you for subscribing to "!groupname!"'
                , failed:         'Unable to subscribe to the following groups:'
                , optinmsg:       'Please check your email and click the link to complete the verification to opt-in for text messages.'
                , textOptInSuccessMessage: 'You are successfully opted in to receive text messages.'
            };

            $scope.nogroupswarning = {
                  type:         'warning'
                , title:        ''
                , text:         'This section will not appear on the public portal page unless at least one group is assigned.<br>Edit this section to assign one or more groups.'
                , dismissable:  false
                , show:         true
                , noshadow:     true
            };

            $scope.errorStrings = {
                errorsTitle: '',
                errorsPleaseCorrect: 'Please correct the issues indicated below.'
            };

            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingSubscribe', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };

            /* Initialize Message to blank - resets message */
            var initMessage = function(){
                // set message defaults
                $scope.message = {
                    key:    '',
                    show:   false,
                    title:  '',
                    text:   '',
                    type:   ''
                };
            };
            // run on first page load
            initMessage();

            // clear all messages (errors)
            var clearMessages = function(key){
                if(typeof type === 'undefined' || $scope.message.key === key){
                    $scope.message = {
                        key:    '',
                        show:   false,
                        title:  '',
                        text:   '',
                        type:   ''
                    };
                }
            };

            /* Display Message */
            var showMessage = function( title, message, type, key ){
                clearMessages();
                // set values to defaults if empty strings
                var mKey = ( typeof key !== 'undefined' && key.length ) ? key : $scope.message.key;
                var mTitle = ( title.length > 0 ) ? title : $scope.message.title;
                var mMessage = ( message.length > 0 ) ? message : $scope.message.text;
                var mType = ( type.length > 0 ) ? type : $scope.message.type;
                // assign values - will be displayed if title or message is not zero-length
                $scope.message = {
                    key:    mKey,
                    show:   false,
                    title:  mTitle,
                    text:   mMessage,
                    type:   mType
                };
                if(type.length > 0 && (title.length > 0 || message.length > 0)){
                    $scope.message.show = true;
                }
            };

            /**
             * Listen for the subscibe save event from the slide out so you can update the Groups list
             */
            $scope.$on('portal_savesubscribe', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update groups
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && typeof val.selectedGroups !== 'undefined'
                    && val.sectionId == $scope.section.id){
                    $scope.frmObjSubscribe.groupsSelect = val.selectedGroups;

                    if($scope.frmObjSubscribe.groupsSelect.length !== 1){
                        //force MultiSelect to re-render
                        refreshMultiSelect();
                    }

                    // Update Section model
                    updateSectionContent();
                }
            });

            /**
             * Loads the selected groups detail info for the subscribe psuedo-form's select list
             *
             */
            var parseData = function(){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': true });

                // data model for backend call
                var data = {
                    owner: SUGUtilities.keyExists($scope.data, 'portalInfo.portal.memberid') ? $scope.data.portalInfo.portal.memberid : 0,
                    portalId: SUGUtilities.keyExists($scope.data, 'portalInfo.portal.id') ? $scope.data.portalInfo.portal.id : 0,
                    portalSectionID: SUGUtilities.keyExists($scope.section, 'id') ? $scope.section.id : 0,
                };

                // grab groups data
                portalService.getSubscribeSectionData_Public( data )
                .then( function(response) {
                    //validate the response
                    if( SUGUtilities.ajaxResultInvalid( response.data ) ){
                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': false });

                        $scope.es.setError('error-subscribe-top-level', SUGUtilities.getAjaxResponseMessage(response));
                    } else {
                        //response was valid
                        var r = SUGUtilities.lowerCaseKeys( response.data );
                        $scope.frmObjSubscribe.groupsSelect = r.data.groups;
                        $scope.frmObjSubscribe.groupsSelect = $filter('orderBy')($scope.frmObjSubscribe.groupsSelect, 'name');
                        // if one group is available set to that group id
                        if( $scope.frmObjSubscribe.groupsSelect.length == 1 ){
                            $scope.frmObjSubscribe.selectedGroups.push( $scope.frmObjSubscribe.groupsSelect[0].id );
                        }
                        else{
                            //force MultiSelect to re-render
                            refreshMultiSelect();
                        }

                        // public view
                        if( $scope.getPortalMode() === 'public' ){

                            SUGUtilities.getReCaptcha({})
                            .then( function(response){
                                var r = SUGUtilities.lowerCaseKeys( response );
                                if( SUGUtilities.ajaxResultInvalid( r.data ) ){
                                    // captcha fail
                                } else {
                                    $scope.captcha = sce.trustAsHtml( r.data.data.snippet );
                                    $scope.recaptchafeature =  r.data.data.feature;
                                }
                            });

                            // set captcha to show or not
                            $scope.showCaptcha = setShowCaptcha();
                        }
                        // portal edit view
                        else{
                            //Update the sectionContent model's firstgroupname value for the Add Section ddl
                            updateSectionContent();
                        }

                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': false });
                    }
                });
            };

            /**
             * Click on subscribe button - ignores action if mode is private
             */
            $scope.subscribeToGroup = function(){
                // if public form, process submission
                if( $scope.getPortalMode() === 'public' ){
                    disableForm(true);

                    //toggle spinner and form disable
                    SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': true });

                    //scroll to the top of the section when form submits
                    var sectionContainer = document.getElementById("sub" + $scope.section.id);
                    if( typeof sectionContainer !== 'undefined' && sectionContainer != null){
                        sectionContainer.scrollIntoView();
                    }

                    if( validateSubsciptionData() ){
                        // process submission
                        var data = {
                            arrGroups: $scope.frmObjSubscribe.selectedGroups,
                            firstname: $scope.frmObjSubscribe.firstname,
                            lastname: $scope.frmObjSubscribe.lastname,
                            email: $scope.frmObjSubscribe.email,
                            portalSectionID: SUGUtilities.keyExists($scope.section, 'id') ? $scope.section.id : 0,
                            textOptIn: !!$scope.frmObjSubscribe.textauth ? 1 : 0,
                            mobile: $scope.frmObjSubscribe.mobile,
                            portalCreatorID: SUGUtilities.keyExists($scope.data, 'portalInfo.portal.memberid') ? $scope.data.portalInfo.portal.memberid : 0,
                        };
                        portalService.subscribeUserToGroups_Public( data )
                            .then( function(response) {
                                //validate the response
                                if( SUGUtilities.ajaxResultInvalid( response.data ) ){
                                    $scope.es.setError('error-subscribe-top-level', SUGUtilities.getAjaxResponseMessage(response));
                                } else {
                                    //response was valid
                                    var r = SUGUtilities.lowerCaseKeys( response.data );
                                    // build outcomes
                                    buildOutcomes( r.data.outcomes, data.textOptIn );
                                    // show outcomes
                                    $scope.outcomes.show = true;
                                }
                                //toggle spinner and form disable
                                SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': false });

                                disableForm(false);
                            });
                    } else {
                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingSubscribe', { 'sectionId': $scope.section.id, 'isprocessing': false });
                    }

                }
            };

            /**
             * Determine portal mode is public or private (portal edit pages)
             * @returns - string - 'public' | 'private' (default)
             */
            $scope.getPortalMode = function(){
                if( SUGUtilities.keyExists($scope.data, 'portalInfo.portal.mode') ){
                    return $scope.data.portalInfo.portal.mode;
                }
                else{
                    return 'private';
                }
            };

            /**
             * This Select picker popup menu is sticky and tends not to show on the slideout in time
             * forcing it to show and render without it looking like it's being added later
             **/
            var refreshMultiSelect = function(){
                var increment = [0, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024];
                for (var stingymenu in increment) {
                    if (increment[stingymenu] !== undefined) {
                        $timeout(function () {
                            angular.element('[name="selectgroups"].selectpicker').selectpicker('render');
                            angular.element('[name="selectgroups"].selectpicker').selectpicker('refresh');
                        }, increment[stingymenu]);
                    }
                }
            };

            /**
             * Updated the specific sectioncontent with relevant info for this section
             */
            var updateSectionContent = function(){
                $scope.section.firstgroupname = ( $scope.frmObjSubscribe.groupsSelect.length ) ? $scope.frmObjSubscribe.groupsSelect[0].name.toString() : "";
            };

            /**
             * Validate subscription submission and provide error feedback
             *
             * @returns {Boolean} - whether data is valid
             */
            var validateSubsciptionData = function(){
                // clear errors
                $scope.es.clearErrors();
                // submission validation
                if( $scope.frmObjSubscribe.groupsSelect.length === 0 ){ // if groups is empty
                    $scope.es.setError('selectgroups','no msg');
                }
                if( $scope.frmObjSubscribe.selectedGroups.length === 0 ){ // if no groups selected
                    $scope.es.setError('selectgroups','no msg');
                }
                if( $scope.frmObjSubscribe.firstname === '' ){
                    $scope.es.setError('subscribefirstname','no msg');
                }
                if( $scope.frmObjSubscribe.lastname === '' ){
                    $scope.es.setError('subscribelastname','no msg');
                }
                if( $scope.frmObjSubscribe.email === '' ){
                    $scope.es.setError('subscribeemail','no msg');
                }
                if( $scope.frmObjSubscribe.email.length && !SUGUtilities.validateEmail( $scope.frmObjSubscribe.email ) ){
                    $scope.es.setError('subscribeemail','You must enter a valid email address');
                }
                if( $scope.frmObjSubscribe.mobile.length && !SUGUtilities.validatePhone( $scope.frmObjSubscribe.mobile ) ){
                    $scope.es.setError('subscribemobile','The mobile number is not valid');
                }
                if( !!$scope.frmObjSubscribe.textauth && !$scope.frmObjSubscribe.mobile.length ){
                    $scope.es.setError('subscribemobile','A mobile number is required to receive text messages');
                }
                if ( $scope.showCaptcha && !$scope.frmObjSubscribe.captchaValid ) {
                    $scope.es.setError('captcha', 'no msg');
                }
                if( $scope.es.hasErrors ){
                    disableForm(false);
                    $scope.es.setError('error-subscribe-top-level', 'no msg');
                    return false;
                }

                return true;
            };

            /**
             * Determine whether to show captcha
             *
             * @returns {Boolean} - whether to show captcha or not
             */
            var setShowCaptcha = function(){
                // if not public, don't show
                if( $scope.getPortalMode() !== 'public' ){
                    return false;
                }
                // if subscribe section count = 1 show
                var subscribeCount = 0;
                for( var i = 0; i < $scope.data.portalInfo.portalsections.length; i++ ){
                    if( $scope.data.portalInfo.portalsections[i].sectionkey === 'subscribe' ){
                        subscribeCount++;
                    }
                }
                if( subscribeCount === 1 ){
                    return true;
                }
                // default to false
                return false;
            };

            /**
             * Build outcomes (success and fail)
             *
             */
            var buildOutcomes = function( outcomes, optin ){
                // iterate outcomes and append to success or fail html variables
                var successhtml = '';
                var failhtml = '';
                var optinresult = {
                    showsuccess: false,
                    showfail: false,
                };
                var successcount = 0;
                var lastGroupNameAdded = '';
                // append group names to outcomes
                outcomes.forEach(function ( outcome, index ) {
                    $scope.frmObjSubscribe.groupsSelect.forEach( function( group, index ){
                        if( outcome.id == group.id ){
                            if( outcome.success ){
                                successhtml += "<li>" + group.name + "</li>";
                                successcount++;
                                lastGroupNameAdded = group.name;
                            }
                            else{
                                failhtml += "<li>" + group.name;
                                switch( outcome.msg ){
                                    case 'not found':   // group id not in the db
                                        break;
                                    case 'not valid':   // group id no longer belongs to the subscribe section
                                        break;
                                    default:    // anything else - should never get here but just in case
                                        if( typeof outcome.msg !== 'undefined' && outcome.msg.length ){
                                            failhtml += " - " + outcome.msg;
                                        }
                                }
                                failhtml += "</li>";
                            }
                        }
                    });
                    if( outcome.id == 0 ){
                        if( outcome.msg == 'opt in success'){
                            optinresult.showsuccess = true;
                        }
                        if( outcome.msg == 'opt in failed'){
                            optinresult.showfail = true;
                        }
                    }
                });

                // if at least partial success, wrap all in success message
                if(successcount === 1){
                    var singleAddSuccessMsg = $filter('sugString')($scope.strings.thankyouSingle, [{
                        'groupname': lastGroupNameAdded
                    }]);
                    if( optinresult.showsuccess || optin ){
                        singleAddSuccessMsg += "<br>" + $scope.strings.textOptInSuccessMessage + "<br>";
                    }
                    showMessage(singleAddSuccessMsg, '', 'success');
                }
                else if( successhtml.length ){
                    var msg = '';
                    // successfully added groups
                    msg += $scope.strings.thankyou + "<ul>" + successhtml + "</ul>";
                    // text optin confirmation
                    if( optinresult.showsuccess || optin ){
                        msg += $scope.strings.textOptInSuccessMessage + "<br><br>";
                    }
                    // failed groups
                    if( failhtml.length ){
                        msg += $scope.strings.failed + "<ul>" + failhtml + "</ul>";
                    }
                    // show message
                    showMessage(msg, '', 'success');
                }
                else if( failhtml.length ){
                    $scope.errorStrings = {
                        errorsTitle: '',
                        errorsPleaseCorrect: $scope.strings.failed,
                    };
                    $scope.es.setError('error-subscribe-top-level', failhtml);
                }
            };

            /**
             * global recaptcha callback
             *
             */
            recaptchaCallback = function( resp ){
                SUGUtilities.validateCaptcha( resp )
                    .then( function(response){
                        var r = SUGUtilities.lowerCaseKeys( response );
                        if( SUGUtilities.ajaxResultInvalid( r.data ) ){
                            $scope.frmObjSubscribe.captchaValid = false;
                        }
                        else {
                            $scope.frmObjSubscribe.captchaValid = r.data.data;
                        }

                    });
            };

            parseData();
        }] // end controller

    }); // END return
}); // END sugSubscribe